import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onClick", "id", "containerClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Components
import Icon from '../FontIcon';

// Styles
import s from './iconAsBtn.module.scss';
var IconAsBtn = /*#__PURE__*/function (_Component) {
  _inherits(IconAsBtn, _Component);
  var _super = _createSuper(IconAsBtn);
  function IconAsBtn() {
    var _this;
    _classCallCheck(this, IconAsBtn);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        id = _this$props.id,
        disabled = _this$props.disabled;
      e.stopPropagation();
      e.preventDefault();
      if (disabled) return;
      onClick(id);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      var _this$props2 = _this.props,
        onMouseDown = _this$props2.onMouseDown,
        id = _this$props2.id,
        disabled = _this$props2.disabled;
      if (disabled) return;
      onMouseDown(e, id);
    });
    return _this;
  }
  _createClass(IconAsBtn, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        onClick = _this$props3.onClick,
        id = _this$props3.id,
        containerClassName = _this$props3.containerClassName,
        restProps = _objectWithoutProperties(_this$props3, _excluded);
      return /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: -1,
        onClick: this.handleClick,
        className: "".concat(containerClassName, " cursor-pointer ").concat(s.container),
        id: id,
        onMouseDown: this.handleMouseDown
      }, /*#__PURE__*/React.createElement(Icon, restProps));
    }
  }]);
  return IconAsBtn;
}(Component);
IconAsBtn.propTypes = {
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  id: PropTypes.string,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool
};
IconAsBtn.defaultProps = {
  onClick: _noop,
  onMouseDown: _noop,
  id: undefined,
  containerClassName: '',
  disabled: false
};
export default IconAsBtn;